import React from "react";
import UserCodeResponse from "./UserCodeResponse";

const CandidateCodingScore = ({ codeResponses }: any) => {
	if (!codeResponses || !codeResponses.coding_evaluation) {
		return <div className="mb-2 mt-[-10px]">No code responses available</div>;
	}
	return (
		<>
			<h2 className="text-xl  text-gray-800 dark:text-white font-subheading">
				Code Responses
			</h2>

			{codeResponses.coding_evaluation.map((evaluation: any, index: number) => {
				return (
					<div
						key={index}
						className="mb-4 font-body border-b-2 pb-2 border-black"
						id="code_response"
					>
						<div className="space-y-4 overflow-y-auto p-2">
							<h3 className=" ">
								<p className="inline-block text-lg">{index + 1}.</p>{" "}
								{evaluation.coding_question.question}
							</h3>

							<div>
								<h3 className="text-gray-700 font-medium">Sample Input:</h3>
								<div className="bg-gray-100 p-3 rounded text-gray-700">
									{evaluation.coding_question.sample_input}
								</div>
							</div>
							<div>
								<h3 className="text-gray-700 font-medium">Sample Output:</h3>
								<div className="bg-gray-100 p-3 rounded text-gray-700">
									{evaluation.coding_question.sample_output}
								</div>
							</div>

							<UserCodeResponse code={evaluation.user_code}></UserCodeResponse>
						</div>
						<h3 className="text-gray-700 font-medium mb-2 ml-2">Scores:</h3>
						<div className="flex justify-center overflow-x-auto shadow-xl rounded-md">
							<table className="w-full border-collapse border  text-sm">
								<thead className="font-subheading">
									<tr className="bg-gray-100">
										<th className="p-3 border-r border-gray-300 text-left">
											Metric
										</th>
										<th className="p-3  text-left">Result</th>
									</tr>
								</thead>
								<tbody className="font-body">
									{Object.entries(evaluation.code_score).map(([key, value]) => {
										if (
											key.replace(/_/g, " ") == "OVERALL SCORE" ||
											key.replace(/_/g, " ") == "justification" ||
											key.replace(/_/g, " ").includes("low")
										)
											return;
										return (
											<tr key={key}>
												<td className="p-3 border-r border-gray-300">
													{key.replace(/_/g, " ")}
												</td>
												<td className={` p-3 `}>{value as React.ReactNode}</td>
											</tr>
										);
									})}
									{Object.entries(evaluation.code_score).map(([key, value]) => {
										if (key.replace(/_/g, " ") === "OVERALL SCORE") {
											return (
												<tr key={key} className="bg-gray-100">
													<td className="p-3 border-r border-gray-300 font-bold">
														Overall Score
													</td>
													<td className={` p-3  font-bold`}>
														{value as React.ReactNode}
													</td>
												</tr>
											);
										}
									})}
								</tbody>
							</table>
						</div>
						<div className="m-2 font-body">
							<strong>Evaluation Remarks :- </strong>
							{evaluation.code_score.justification}
						</div>
						<div className="flex flex-col gap-3 justify-center overflow-x-auto ">
							<p className="font-bold font-subheading mt-2 text-lg">
								Code Followup Responses
							</p>
							<p>1. {evaluation.code_followup_question.question} </p>
							<div className="">
								<strong>Answer:</strong>{" "}
								{evaluation.code_followup_question.answer}{" "}
							</div>
							<div className="">
								<strong>AI Feedback:</strong>{" "}
								{evaluation.code_followup_question.feedback.feedback}{" "}
							</div>
						</div>
					</div>
				);
			})}
		</>
	);
};

export default CandidateCodingScore;
